<a
  (click)="tooltip ? openTooltip() : openModal()"
  (keydown.Enter)="tooltip ? openTooltip() : openModal()"
  *ngIf="modalContent || modalTemplate"
  [attr.aria-label]="srText + ' help opens in new pop up'"
  [ngClass]="{
    'idp-label-info-anchor': labelIcon,
    'idp-icon-info-anchor__help-icon': helpIcon,
    'idp-icon-info__focus': config.focus === 'default'
  }"
  aria-haspopup="true"
  class="idp-icon-info-anchor"
  data-test-help-icon="true"
  href="javascript:void(0)"
>
  <i
    aria-hidden="true"
    class="idp-icon-info"
    [ngClass]="{
      'idp-icon-info__position-center': config.position === 'center',
      'idp-icon-info__white': config.color === 'white'
    }"
    [attr.data-cy]="'idp-icon-info'"
  ></i>
</a>
<idp-simple-modal
  (keydown.shift.tab)="tabHandler($event)"
  (openChange)="closeModal()"
  (previousTab)="closeIconReverseTab($event)"
  *ngIf="!enableTooltip"
  [closeOnBackgroundClick]="closeOnBackgroundClick"
  [modalStyle]="modalStyle"
  [modalTitle]="modalTitle"
  [open]="open"
  [scrollModal]="true"
  [showCloseButton]="false"
  [showFooter]="false"
  [tabIndex]="'-1'"
  [attr.data-cy]="'idp-simple-modal'"
>
  <ng-container *ngIf="modalTemplate">
    <ng-content></ng-content>
  </ng-container>
  <div *ngIf="modalContent" class="modal-content__wrapper">
    <section [innerHTML]="modalContent"></section>
  </div>
  <div
    *ngIf="!hideCloseButton"
    [ngClass]="setCloseButtonClasses()"
    data-test-close-wrapper
  >
    <idp-button
      (keydown.shift.tab)="tabHandler($event, true)"
      (keydown.tab)="tabHandler($event)"
      (notify)="closeModal()"
      [ariaLabel]="'Close'"
      [id]="'closeButton'"
      [label]="closeButtonLabel"
      data-test-close-button="true"
      size="wide"
      type="secondary"
      [attr.data-cy]="'close-button'"
    ></idp-button>
  </div>
</idp-simple-modal>

<idp-error-tooltip
  (focusoutInfoToolTip)="closeTooltip()"
  (closePopUp)="closeTooltipPopup(showCloseIconToolTip, closeEscInfoToolTip)"
  *ngIf="enableTooltip"
  [arrowPosition]="arrowPosition"
  [closeIcon]="showCloseIconToolTip"
  [errorMessage]="tooltipContent"
  [closeEscInfoToolTip]="closeEscInfoToolTip"
  [infoToolTip]="infoToolTip"
  [icon]="false"
  [focus]="true"
  [tooltipPosition]="config.tooltipPosition"
  [config]="config"
  data-test-error-tooltip="false"
  [attr.data-cy]="'idp-error-tooltip'"
></idp-error-tooltip>
